<app-block-wrapper
  [_editable]="_editable"
  [style]="style"
  class="storyblok-content-block force-primary-links size-{{ textSize || 'body-lg' }} style-{{
    textStyle || 'text-default'
  }} {{ effectiveAlignment }} a-m-{{ mobileAlignment }} a-t-{{ tabletAlignment }} a-d-{{ desktopAlignment }} {{
    mobileType() ? 'type-scale-mobile' : ''
  }}"
  [class.custom-ul-icons]="!!ulIcons"
  [style.--custom-ul-icon]="ulIcons ? 'url(/assets/icons/' + ulIcons + '.svg)' : undefined"
  [style.--custom-ul-icon-color]="ulIconColor ? 'var(--color-' + ulIconColor + ')' : undefined"
  appRouteDirective
>
  @for (content_item of contents; track content_item; let i = $index) {
    @if (content_item.type !== 'components') {
      <div
        [innerHtml]="content_item | storyblokRichText: style[0] : stripPastedMarks() | safeHtml"
        [class.first]="i === 0"
      ></div>
    }
    @if (content_item.type === 'components') {
      @for (blok of content_item['body']; track blok._uid) {
        <ndc-dynamic
          [ndcDynamicComponent]="$any(components[blok.component])"
          [ndcDynamicInputs]="dynamicInputs($any(blok))"
        ></ndc-dynamic>
      }
    }
  }
</app-block-wrapper>
